/* eslint-disable complexity */
import { LOCAL_STORAGE, VISITOR_SOURCE } from '../constants/local-storage';
import { setItemWithExpiry } from '../utils/local-storage-with-expiry';

export const getUtmCampaign = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const paramsToCheck = [
    'utm_campaign',
    'utm_medium',
    'utm_term',
    'utm_content',
    'gclid',
    'fbclid',
    'ttclid',
  ];

  const hasParam = paramsToCheck.some((param) => urlParams.has(param));

  const setUtmLocalStorage = (utm: string, localStorageValue: string) => {
    if (urlParams.has(utm)) {
      const utmValue = urlParams.get(utm);

      if (utmValue) setItemWithExpiry(localStorageValue, utmValue);
    }
    if (!urlParams.has(utm) && hasParam) {
      localStorage.removeItem(localStorageValue);
    }
  };

  if (urlParams.has('fingerprint')) {
    const fingerprint = urlParams.get('fingerprint');

    if (fingerprint && !localStorage.getItem(LOCAL_STORAGE.xFingerprint))
      localStorage.setItem(LOCAL_STORAGE.xFingerprint, fingerprint);
  }

  if (urlParams.has('utm_source')) {
    const utmSource = urlParams.get('utm_source');

    if (utmSource) setItemWithExpiry(LOCAL_STORAGE.utm_source, utmSource);
  }

  if (urlParams.has('clickid') || urlParams.has('click_ID')) {
    let clickid: string | null = '';

    if (urlParams.has('clickid')) {
      clickid = urlParams.get('clickid');
    }
    if (urlParams.has('click_ID')) {
      clickid = urlParams.get('click_ID');
    }

    if (clickid) localStorage.setItem(LOCAL_STORAGE.clickid, clickid);
  }

  if (urlParams.has('wm_id')) {
    const wmId = urlParams.get('wm_id');

    if (wmId) localStorage.setItem(LOCAL_STORAGE.wm_id, wmId);
  }

  if (urlParams.has('utm_content')) {
    const utmContent = urlParams.get('utm_content');

    if (utmContent) {
      localStorage.setItem(LOCAL_STORAGE.refCode, utmContent);
      setItemWithExpiry(LOCAL_STORAGE.utm_content, utmContent);
    }
  }

  if (urlParams.has('utm_campaign')) {
    const utmCampaign = urlParams.get('utm_campaign');

    if (utmCampaign) {
      if (
        !urlParams.has('utm_content') ||
        (urlParams.has('utm_content') && urlParams.get('utm_content') === '')
      ) {
        localStorage.setItem(LOCAL_STORAGE.refCode, utmCampaign);
      }
      setItemWithExpiry(LOCAL_STORAGE.utm_campaign, utmCampaign);
    }
  }

  setUtmLocalStorage('utm_medium', LOCAL_STORAGE.utm_medium);
  setUtmLocalStorage('utm_term', LOCAL_STORAGE.utm_term);
  setUtmLocalStorage('gclid', LOCAL_STORAGE.gclid);
  setUtmLocalStorage('fbclid', LOCAL_STORAGE.fbclid);
  setUtmLocalStorage('ttclid', LOCAL_STORAGE.ttclid);

  if (urlParams.has('fingerprint_request_id') && urlParams.has('fingerprint_visitor_id')) {
    const fingerprintRequestId = urlParams.get('fingerprint_request_id');
    const fingerprintVisitorId = urlParams.get('fingerprint_visitor_id');

    const visitorData = {
      visitorId: fingerprintVisitorId,
      visitorSource: VISITOR_SOURCE.landing,
      requestId: fingerprintRequestId,
    };

    localStorage.setItem(LOCAL_STORAGE.xFingerprintVisitorId, JSON.stringify(visitorData));
  }

  const isGaidInParams = urlParams.has('gaid');
  const isGaidInLs = !!localStorage.getItem(LOCAL_STORAGE.gaid);

  if (urlParams.has('gaid')) {
    const gaid = urlParams.get('gaid');

    if (gaid && !localStorage.getItem(LOCAL_STORAGE.gaid))
      localStorage.setItem(LOCAL_STORAGE.gaid, gaid);
  }
  if (urlParams.has('blackbox')) {
    const blackbox = urlParams.get('blackbox');

    sessionStorage.setItem(
      LOCAL_STORAGE.fingerprintTrustDecision,
      JSON.stringify({
        visitorSource: 'landing',
        requestId: blackbox,
      }),
    );
  }
  if (!isGaidInParams && !isGaidInLs) {
    const gaidCookie = document.cookie
      ?.split(';')
      ?.find((item) => item.trim().startsWith('_ga='))
      ?.trim()
      ?.slice(4);

    if (gaidCookie) {
      localStorage.setItem(LOCAL_STORAGE.gaid, gaidCookie);
    }
  }
};
